// eslint-disable-next-line no-restricted-imports
import {
  QueryInput_OperationController_GetList_SortOrder as SortOrderApi,
  useOperationGetListQuery,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import {
  parseOperationFiltersParam,
  parseOperationListItemData,
} from 'api/helpers/operation';
import { ListDataQueryFunction } from 'api/types/data';
import { ListData } from 'api/types/data/listData';
import {
  OperationListItemData,
  OperationsFilterParams,
  OperationsSortField,
} from 'api/types/data/operation';
import { lodash } from 'helpers';
import { SortDirection } from 'libs/ui';

const sortMap: Record<NonNullable<SortDirection>, SortOrderApi> = {
  desc: SortOrderApi.Desc,
  asc: SortOrderApi.Asc,
};

export const useOperationGetList: ListDataQueryFunction<
  OperationListItemData,
  OperationsFilterParams,
  OperationsSortField
> = ({ pagination, sort, filter }) => {
  const {
    data,
    loading,
    error: apolloError,
  } = useOperationGetListQuery({
    variables: {
      limit: pagination.limit,
      page: pagination.page + 1,
      sortBy: sort?.field,
      sortOrder: sort?.sort ? sortMap[sort.sort] : sortMap.desc,
      ...parseOperationFiltersParam(filter),
    },
  });

  const error = useError(apolloError);

  const listData: ListData<OperationListItemData> | undefined = data?.operations
    ? {
        total: data.operations.total,
        list: lodash
          .compact(data.operations.list)
          .map(parseOperationListItemData),
      }
    : undefined;

  return {
    listData,
    loading,
    error,
  };
};
